function get_default_system_field(default_source_type) {
  const system_field =
    default_source_type === "system_field" ? "entity_name" : "";

  return system_field;
}

function ensure_defined_value(value, fallback_value) {
  const resolved_value = value === undefined ? fallback_value : value;

  return resolved_value;
}

export function build_default_formal_document_binding(default_source_type = "system_field") {
  const default_binding = {
    source_type: default_source_type,
    system_field: get_default_system_field(default_source_type),
    section_question_id: "",
    question_label: "",
    value: "",
  };

  return default_binding;
}

export function ensure_formal_document_binding(
  binding,
  default_source_type = "system_field"
) {
  const is_invalid_binding =
    !binding || typeof binding !== "object" || Array.isArray(binding);

  if (is_invalid_binding) {
    const default_binding =
      build_default_formal_document_binding(default_source_type);

    return default_binding;
  }

  const normalized_binding = binding;
  const default_system_field = get_default_system_field(default_source_type);

  normalized_binding.source_type =
    normalized_binding.source_type || default_source_type;
  normalized_binding.system_field = ensure_defined_value(
    normalized_binding.system_field,
    default_system_field
  );
  normalized_binding.section_question_id = ensure_defined_value(
    normalized_binding.section_question_id,
    ""
  );
  normalized_binding.question_label = ensure_defined_value(
    normalized_binding.question_label,
    ""
  );
  normalized_binding.value = ensure_defined_value(
    normalized_binding.value,
    ""
  );

  return normalized_binding;
}
